import { useState } from 'react'
import './App.css'
import ProgressHeader from './components/ProgressHeader/ProgressHeader'
import FormContainer from './components/FormContainer/FormContainer'
import EnterpriseHeader from './components/EnterpriseHeader/EnterpriseHeader'
import EnterpriseFooter from './components/EnterpriseFooter/EnterpriseFooter'
import GoToTopButton from './components/GoToTopButton/GoToTopButton'

function App() {
  const [language, setLanguage] = useState('de')
  const [progress, setProgress] = useState(0)

  return (
    <div className="app" id="top">
      <div className="app__sticky-top">
        <EnterpriseHeader language={language} onLanguageChange={setLanguage} />
        <ProgressHeader progress={progress} language={language} />
      </div>

      <FormContainer language={language} onProgressChange={setProgress} />
      <EnterpriseFooter language={language} />
      <GoToTopButton language={language} />
    </div>
  )
}

export default App